import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import { useApp } from '../../context';

function NavbarToggle({ full = false }) {
  const { app, updateApp } = useApp();

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    updateApp({ menuVisible: !app.menuVisible });
  };

  return (
    <nav className="nav ms-auto">
      <Button
        onClick={handleToggleSidebar}
        className={`nav-link nav-link-icon toggle-sidebar text-center${
          !full ? ' d-sm-inline d-md-none d-lg-none' : ''
        }`}
      >
        <i className="fas fa-bars" />
      </Button>
    </nav>
  );
}

NavbarToggle.propTypes = {
  /**
   * The visibility of the sidebar, if full, it will be hidden
   */
  full: PropTypes.bool,
};

export default NavbarToggle;
